import { checkUserLogin } from '@factories/profile';
import { useOktaAuth } from '@okta/okta-react';
import { setServiceIsDown } from '@redux/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route } from 'react-router-dom';

type RoutesAuthCheckProps = {
    redirectTo: string;
    isSecure: boolean;
    children?: JSX.Element;
    props?: never;
}
export const RoutesAuthCheck = ({
    redirectTo, isSecure, children, ...props
}: RoutesAuthCheckProps): JSX.Element => {
    const dispatch = useDispatch();
    const { oktaAuth } = useOktaAuth();

    useEffect(() => {
        let timeoutId: NodeJS.Timeout | null = null;
        const addSessionExpiryTimeout = (expiresIn: number) => {
            timeoutId = setTimeout(() => {
                // redirect to Session expiry page
                window.location.assign(`${window.location.origin}/logout?expired=true`);
            }, expiresIn);
        };

        const userLogin = async () => {
            await checkUserLogin()
                .then(async (res: {
                    status: number; url: string | URL; expiresIn: number;
                }) => {
                    if ([200, 304].includes(res?.status) && res?.expiresIn && isSecure) {
                        timeoutId && clearTimeout(timeoutId);
                        timeoutId == null && res?.expiresIn && addSessionExpiryTimeout(res.expiresIn);
                        dispatch(setServiceIsDown(false));
                    }
                    else if (res?.status === 401 && isSecure) {
                        dispatch(setServiceIsDown(false));
                        await oktaAuth.tokenManager.clear();
                        timeoutId && clearTimeout(timeoutId);
                        return window.location.assign(`${window.location.origin}/logout`);
                    }
                    else if (res?.url) {
                        return window.location.assign(res.url);
                    }
                }).catch(() => dispatch(setServiceIsDown(true)));
        };
        userLogin();
        return () => { timeoutId && clearTimeout(timeoutId); };
    }, [isSecure]);

    useEffect(() => {
        const userAgent = navigator.userAgent;
        const isIE = userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident/') > -1;
        if (isIE) {
            return location.assign('/obsoleteBrowser');
        }
    }, []);

    return (
        <>
            <Route {...props} path={`${redirectTo}`}>{children}</Route>
        </>
    );
};
